<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="file-upload-popup">
      <div class="popup-header">
        <div class="popup_title">파일 요청</div>
        <img src="@/assets/images/close_btn.png" @click="closePopup(false)" class="close_icon" />
      </div>
      <div class="popup-body">
        <div class="popup_desc">필요한 파일명을 선택 또는 입력하세요.</div>
        <Select2 v-model="파일제목" :options="구분목록" :settings="{height:'24px',width:'100%',tags:true}"/>
      </div>
      <div class="popup-footer">
        <div class="popup_close_btn" @click="closePopup(false)">취소</div>
        <div class="popup_confirm_btn" @click="requestFile">등록</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps, onMounted } from "vue";
import anncounceAPI from "../../api/announceAPI";
import codeAPI from "@/api/codeAPI";

const props = defineProps<{
  공고순번: number | null;
  수주수행구분: string | null;
}>();

const emit = defineEmits(["closePopup"]);

// HTMLInputElement 타입을 명시적으로 지정
const fileInp = ref<HTMLInputElement | null>(null);
const 파일제목 = ref<string>("");

// Param 인터페이스 정의하여 param 타입 지정
interface Param {
  // 첨부파일명: string;
  // 첨부파일처리: string;
  회원구분: string | null;
  파일제목: string | null;
  자료식별값2: string | null;
}

const param = ref<Param>({
  // 첨부파일명: "",
  // 첨부파일처리: "",
  회원구분: "",
  파일제목: "",
  자료식별값2: "",
});
const 구분목록 = ref<{ id: string; text: string }[]>([]);
onMounted(async() => {
  await codeAPI.getSelectedCode('0002').then((res) => {
    구분목록.value = res.data.data.map((item: any) => { 
      return {id:item.코드,text:item.코드명}
    });
  });
})
const requestFile = () => {
  console.log(isNaN(Number(파일제목.value)))
  if (!파일제목.value) {
    alert("파일 제목을 입력해주세요.");
    return;
  }

  param.value.회원구분 = props.수주수행구분;
  param.value.파일제목 = 파일제목.value;
  param.value.자료식별값2 = props.수주수행구분;

  if (props.공고순번 === null) {
    alert("공고순번이 null입니다. 파일요청을 진행할 수 없습니다.");
    return;
  }
  anncounceAPI
    .repuestAnnounceFile(props.공고순번, param.value)
    .then((res) => {
      if (res.data.success) {
        alert("등록이 완료되었습니다.");
        closePopup(true);
      }
    })
    .catch((error) => {
      console.error("파일 업로드 중 오류 발생:", error);
    });
};

function closePopup(refresh: boolean) {
  emit("closePopup", { popupType: "fileRequest", refresh });
}
</script>

<style scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.file-upload-popup {
  /* Add your styles here */
  left: 50%;
  position: fixed;
  background-color: white;
  width: 439px;
  height: 296px;
  background: white;
  top: calc(50% - 231.5px);
  left: calc(50% - 219.5px);
  border-radius: 11px;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  padding: 40px;
  height: 154px;
}
.popup_desc {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  line-height: 20px;
  color: black;
  margin-bottom: 15px;
}
.file_title {
  border: 1px solid #d0d0d0;
  height: 39px;
  width: 100%;
  border-radius: 4px;
  padding-left: 12px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  margin-bottom: 15px;
}
.file_upload_area {
  height: 145px;
  border: 1px solid #dbdbdb;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #838383;
  gap: 10px;
  border-radius: 4px;
  cursor: pointer;
}
.file_upload_area.upload {
  cursor: default;
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0px 40px;
  gap: 10px;
}
.file_inp {
  width: 0px;
  height: 0px;
}
.popup_close_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ededed;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #383838;
  font-size: 14px;
  cursor: pointer;
}
.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3382e9;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.close_icon {
  cursor: pointer;
}
</style>
